{
    "AllTelServer": "[Alle telefonieservers]",
    "AnyPartition": "[Elke partitie]",
    "AnyDevices": "[Elk apparaat]",
    "AnyAgents": "[Elke ACD-agent]",
    "AnyAgentForDevice": "[Elk op ingesteld apparaat]",
    "AnyDeviceForAgent": "[Elke met ingestelde ACD-agent]",
    "DeviceValidation": "Serviceniveau-instellingen",
    "AgentValidation": "Een beheerder kan geen agentmachtigingsniveau instellen",
    "PermissionsLanguage_PermissionsNote": "Serviceniveau-instellingen",
    "PermissionsLanguage_CmEnvironment": "CME-details",
    "PermissionsLanguage_TelServer": "Telefonieserver:",
    "PermissionsLanguage_Partition": "partitie:",
    "PermissionsLanguage_Device": "Groep\/Apparaat:",
    "PermissionsLanguage_AndOrAgent": "Tussenpersoon:",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Voor dit gebruikerstype moet een toestemmingsapparaat zijn ingesteld",
    "EssentialsDeviceValidation_MST": "Een CXA Standard-gebruiker moet een apparaat met toestemmingen hebben ingesteld",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Supervisor-machtigingen synchroniseren vanuit telefonieplatform",
    "BusinessManagerPartitionValidation": "Een manager met beheerdersrechten moet toegang hebben tot alle partities (op systeemniveau van het telefoniesysteem).",
    "EssentialsDeviceValidation_MSTB": "Een historische gebruiker moet beschikken over een apparaat met machtigingen.",
    "ProfessionalDeviceValidation": "Een professionele gebruiker moet beschikken over een apparaat met de juiste machtigingen.",
    "ProfessionalDeviceValidation_MSTB": "Een realtimegebruiker moet beschikken over een apparaat met de juiste machtigingen."
}